import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./EditReferralCodeForm";
import Loading from "../../components/Loading";
import {cancelEditReferralCode} from "../../actions/SalesApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "code");
  errors = validatePresence(errors, values, "description");
  return errors.toJS();
}

function coerceBoolean(val) {
  if (val === "true") return true;
  if (val === true) return true;
  return false;
}


class EditReferralCodeFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("active", coerceBoolean(values.get("active")));
    return this.props.updateReferralCode(updatedValues.toJS())
      .then((response) => {
        if (response.data.updateReferralCode.errors.length <= 0) {
          this.props.cancelEditReferralCode();
        } else {
          let errors = createValidationErrors(response.data.updateReferralCode.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelEditReferralCode();
  }

  render() {
    let {loading, error, referralCode} = this.props.data;
    if (loading) return <Loading />
    if (error) return <Loading />

    let initialValues = fromJS({
      code: referralCode.code,
      description: referralCode.description,
      active: referralCode.active
    })
    return (
      <Form
        disableCode={true}
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const GET_REFERRAL_CODE = gql`
  query referralCode($code:ID!) {
    referralCode(code: $code) {
      code
      description
      active
    }
  }
`

const UPDATE_REFERRAL_CODE = gql`
  mutation updateReferralCode($data: ReferralCodeInput!) {
    updateReferralCode(input: $data) {
      errors { key message }
    }
  }
`


const withQueries = compose(
  graphql(GET_REFERRAL_CODE, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        code: props.code
      }
    })
  }),
  graphql(UPDATE_REFERRAL_CODE, {
    props: ({mutate}) => ({
      updateReferralCode: (data) => mutate({
        variables: {data: data}
      })
    })
  })
)

export default connect(null, {cancelEditReferralCode})(withQueries(EditReferralCodeFormContainer));